import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { productService } from "../../services/product.service";
import { showToast } from "../../lib/toast";
import {
  ProductForm,
  type ProductFormData,
} from "../../components/products/ProductForm";

export function CreateProductPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (data: ProductFormData) => {
    setError("");
    setLoading(true);

    try {
      await productService.createProduct({ ...data, sku: data.sku || "" });
      showToast.success("Product created successfully");
      navigate("/products");
    } catch (err: any) {
      const errorMsg =
        err.response?.data?.message || "Failed to create product";
      showToast.error(errorMsg);
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Add New Product</h1>
        <p className="text-sm text-gray-600 mt-1">
          Fill in the essential details. Optional fields can be expanded below.
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <ProductForm
        mode="create"
        onSubmit={onSubmit}
        onCancel={() => navigate("/products")}
        isLoading={loading}
      />
    </div>
  );
}
